import { HttpMethod, HttpOption } from '@/utils/http-client'

export class RoutingAPIConstant {
    /**
     * 条件分页查询放款路由列表
     */
    OutComeRouteManageList = (data): HttpOption => ({
        url: '/front/outComeRouteManage/list',
        method: HttpMethod.POST,
        data
    })

    /**
     * 添加放款路由
     */
    AddOutComeRoute = (data): HttpOption => ({
        url: '/front/outComeRouteManage/add',
        method: HttpMethod.POST,
        data
    })

    /**
     * 更新放款路由
     */
    UpdateOutComeRoute = (data): HttpOption => ({
        url: '/front/outComeRouteManage/update',
        method: HttpMethod.POST,
        data
    })

    /**
     * 根据渠道id查询路由对照配置的银行列表
     */
    QueryBankListByChannelId = (data): HttpOption => ({
        url: '/front/routeControl/queryBankListByChannelId',
        method: HttpMethod.POST,
        data
    })

    /**
     * 条件分页查询还款路由列表
     */
    DeDuctManageList = (data): HttpOption => ({
        url: '/front/deDuctManage/list',
        method: HttpMethod.POST,
        data
    })

    /**
     * 添加还款路由
     */
    AddDeDuct = (data): HttpOption => ({
        url: '/front/deDuctManage/add',
        method: HttpMethod.POST,
        data
    })

    /**
     * 更新还款路由
     */
    UpdateDeDuct = (data): HttpOption => ({
        url: '/front/deDuctManage/update',
        method: HttpMethod.POST,
        data
    })
}
